import { ContactCard, Delete, Edit, Favorite, Root } from './components';

export const CompanyLinkActions = Object.assign(Root, {
  ContactCard,
  Favorite,
  Edit,
  Delete,
});
